<template>
  <div>
    <!-- <div class="page-image">
       <img class="logo" src="../images/start_page/bg-logo@2x.png" alt="">
       <img class="NEWHOPE" src="../images/start_page/NEWHOPE@2x.png" alt="">
       <img class="NEWHOPE_jz" src="../images/start_page/jz@2x.png" alt="">
     </div>
     <div class="page-footer">
       <p>新希望地产版权所有 ©️2019-2029</p>
    </div>-->
  </div>
</template>

<script>
import { Toast } from 'vant';

export default {
  data() {
    return {
      loading: true,
      ticket: '',
      redirect: '',
      token: '',
    };
  },
  created() {
    // 进入登录页面先清空个人信息
    this.ticket = this.$route.query.ticket;
    this.token = this.$route.query.token;
    this.redirect = this.$route.query.redirect;
    this.gys = this.$route.query.gys;
    this.rh = this.$route.query.rh;
    this.notLogin = this.$route.query.notLogin;
    this.ygtj = this.$route.query.ygtj;
    this.jdgj = this.$route.query.jdgj;
    if (this.ticket) {
      this.doLoginByTicket();
    } else if (this.token) {
      this.h5InvestLoginByApp();
    } else if (this.rh) {
      this.appEventsGo();
    } else if (this.gys) {
      this.appEvents();
    } else if (this.notLogin) {
      this.appEvents();
    } else if (this.ygtj) {
      this.appEvents('recommend');
    } else if (this.jdgj) {
      this.appEvents('progress');
    } else if (this.$route.query.wxToken) {
      this.doLoginByWxToken();
    } else if (this.$store.state.user.oauth) {
      this.goBeforeLoginUrl();
    } else {
      this.$store.dispatch('goLogin').then(() => {
        this.goBeforeLoginUrl();
      });
    }
  },
  methods: {
    // 融合计划带地址跳转
    appEventsGo() {
      this.$jsBridge.callHandler('getAccessToken', '', (res) => {
        if (res) {
          this.$store
            .dispatch('h5InvestLoginByApp', res)
            .then(() => {
              this.goRh();
            })
            .catch((err) => {
              this.$jsBridge.commonCall('finish', '');
            });
        } else {
          Toast('未获取到token');
        }
      });
    },
    // 所有H5地址带参数跳转
    appEvents(address = '') {
      this.$jsBridge.callHandler('getAccessToken', '', (res) => {
        if (res) {
          this.$store
            .dispatch('h5InvestLoginByApp', res)
            .then(() => {
              this.goBeforeLoginUrl(address);
            })
            .catch((err) => {
              // alert(JSON.stringify(err));
            });
        } else {
          Toast('未获取到token');
        }
      });
    },
    /**
			 登陆
			 */
    doLoginByTicket() {
      this.$store
        .dispatch('doLoginByTicket', {
          ticket: this.ticket,
          redirect: this.redirect,
          domain: this.$config.baseURL,
        })
        .then(() => {
          this.goBeforeLoginUrl();
        });
    },
    /**
     * 登陆
     */
    h5InvestLoginByApp() {
      this.$store.dispatch('h5InvestLoginByApp', this.token).then(() => {
        this.goBeforeLoginUrl();
      });
    },
    /**
     * wxToken登陆
     */
    doLoginByWxToken() {
      this.$store
        .dispatch('doLoginByWxToken', this.$route.query.wxToken)
        .then(() => {
          this.goBeforeLoginUrl();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.page-author {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  position: relative;
  .page-title {
    width: 100%;
    font-size: 60px;
    font-weight: 400;
    padding-bottom: 120px;
  }
  .page-image {
    width: 100%;
    position: relative;
    text-align: center;
    & > img.logo {
      display: block;
      width: 100%;
      max-width: 36%;
      max-height: 357px;
      margin: 0 auto;
    }
    & > img.NEWHOPE {
      display: inline-block;
      max-width: 80%;
      margin: 10px 0;
    }
    & > img.NEWHOPE_jz {
      display: inline-block;
      max-width: 27%;
    }
  }
  .page-footer {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    text-align: center;
    padding-bottom: 20px;
    & > p {
      font-size: 24px;
      font-family: PingFang-SC-Regular;
      font-weight: 400;
      color: #434540;
      line-height: 2;
      &.title {
        font-size: 48px;
        font-family: PingFang-SC-Medium;
        font-weight: 500;
      }
    }
  }
}

.page-author {
  background: url('../images/start_page/bg@2x.png') no-repeat 0 0;
  background-size: cover;
}
</style>
